
const NoSafcomData = ()=>{

        return(
            <>
             <div className="flex items-center justify-center min-h-screen bg-green-500">
             <div className="bg-white shadow-lg rounded-2xl p-8 text-center">
             <h1 className="text-xl font-semibold text-gray-800"> Kindly switch on your Safaricom data to enjoy the service</h1>
                </div>
            </div>
            </>
        );
};

export default NoSafcomData;